import { render, staticRenderFns } from "./merchant.vue?vue&type=template&id=5aa143e1&scoped=true&"
import script from "./merchant.vue?vue&type=script&lang=ts&"
export * from "./merchant.vue?vue&type=script&lang=ts&"
import style0 from "./merchant.vue?vue&type=style&index=0&id=5aa143e1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa143e1",
  null
  
)

export default component.exports